/* ==================================================================
   Le menu de Tom & Mila, telephone. 2026-09-21
   ==================================================================
   Charge par sections/tm-charte.liquid. Deux blocs :
   1. la recherche en haut du tiroir et les liens de compte en bas ;
   2. l'accordeon, complement indispensable au CSS.
   Aucun fichier Dawn n'est modifie. Le raisonnement complet, les
   specificites CSS et les pieges du JavaScript de Dawn sont dans
   theme/tiroir-accordeon.md.
   ================================================================== */

/* Le socle commun aux deux champs de recherche, celui du tiroir et la
   boite de l'en-tete. Une seule liste de phrases, une seule machine a
   ecrire : les deux doivent dire la meme chose. */
var TM = window.TM || (window.TM = {});

TM.PHRASES = [
  'Je recherche une huile de massage',
  'Je recherche un anneau vibrant',
  'Je recherche un jeu à deux',
  'Je recherche un lubrifiant',
  'Je recherche une marque'
];

/* elTexte : le noeud qui porte la phrase. enPause : une fonction qui rend
   vrai quand il faut s'arreter, le temps que l'utilisateur tape ou que la
   boite soit masquee.
   ⚠️ La phrase est posee ENTIERE avant tout : si le minuteur ne part
   jamais, il reste du texte lisible. Rien ne part d'un etat vide. */
TM.machine = function (elTexte, enPause) {
  var P = TM.PHRASES;
  elTexte.textContent = P[0];
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var phrase = 0, lettre = P[0].length, efface = true;
  var dort = false, dernierTest = 0;
  /* enPause() lit la mise en page, par offsetParent, ce qui force le
     navigateur a recalculer. Le demander a chaque lettre, c'est jusqu'a 38
     recalculs par seconde, et c'est une cause directe de ralentissement sur
     un telephone ancien. La visibilite ne change pas au milieu d'un mot, et
     l'effacement de la phrase au focus est fait par le CSS, pas d'ici : on
     ne pose donc la question que trois fois par seconde. */
  function assoupi() {
    var t = Date.now();
    if (t - dernierTest > 320) { dernierTest = t; dort = enPause(); }
    return dort;
  }
  function tic() {
    if (assoupi()) return setTimeout(tic, 700);
    var mot = P[phrase];
    if (efface) {
      lettre--;
      elTexte.textContent = mot.slice(0, lettre);
      if (lettre <= 0) { efface = false; phrase = (phrase + 1) % P.length; return setTimeout(tic, 420); }
      return setTimeout(tic, 26);
    }
    lettre++;
    elTexte.textContent = P[phrase].slice(0, lettre);
    if (lettre >= P[phrase].length) { efface = true; return setTimeout(tic, 1800); }
    return setTimeout(tic, 58);
  }
  setTimeout(tic, 1800);
};

TM.pret = function (f) {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', f);
  else f();
};

  /* Le tiroir du telephone, 2026-09-21.
     Deux ajouts, tous deux poses par ce script : un champ de recherche en
     haut, et les liens de compte en bas. Aucun fichier Dawn n'est modifie.
     Le formulaire pointe vers /search, l'adresse standard de Shopify.
     Si la structure du tiroir change, le script ne trouve rien et ne fait rien. */
  (function () {
    var PHRASES = TM.PHRASES;

    function svg(chemins) {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('viewBox', '0 0 22 22');
      s.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < chemins.length; i++) {
        var e = document.createElementNS('http://www.w3.org/2000/svg', chemins[i][0]);
        for (var a in chemins[i][1]) e.setAttribute(a, chemins[i][1][a]);
        s.appendChild(e);
      }
      return s;
    }

    function poserRecherche(hote) {
      if (hote.querySelector('.tm-rech')) return;

      var f = document.createElement('form');
      f.className = 'tm-rech';
      f.setAttribute('action', '/search');
      f.setAttribute('method', 'get');
      f.setAttribute('role', 'search');

      var boite = document.createElement('div');
      boite.className = 'tm-rech__boite';

      var loupe = svg([['circle', { cx: '9.2', cy: '9.2', r: '6.8' }],
                       ['path', { d: 'M14.3 14.3 L19.6 19.6' }]]);
      loupe.setAttribute('class', 'tm-rech__loupe');

      var champ = document.createElement('input');
      champ.className = 'tm-rech__champ';
      champ.setAttribute('type', 'search');
      champ.setAttribute('name', 'q');
      champ.setAttribute('placeholder', ' ');
      champ.setAttribute('autocomplete', 'off');
      champ.setAttribute('aria-label', 'Rechercher un produit');

      var indice = document.createElement('span');
      indice.className = 'tm-rech__indice';
      indice.setAttribute('aria-hidden', 'true');
      var texte = document.createElement('span');
      texte.textContent = PHRASES[0];
      var curseur = document.createElement('span');
      curseur.className = 'tm-rech__curseur';
      indice.appendChild(texte); indice.appendChild(curseur);

      boite.appendChild(loupe); boite.appendChild(champ); boite.appendChild(indice);

      var portee = document.createElement('input');
      portee.setAttribute('type', 'hidden');
      portee.setAttribute('name', 'options[prefix]');
      portee.setAttribute('value', 'last');

      f.appendChild(boite); f.appendChild(portee);
      hote.insertBefore(f, hote.firstChild);

      /* La machine a ecrire, commune avec la boite de l'en-tete.
         ⚠️ ELLE S'ARRETE AUSSI TIROIR FERME. Sans cette garde elle tourne en
         permanence, y compris sur ordinateur ou le tiroir n'existe pas, et
         on ouvre le menu au milieu d'un mot en train de s'effacer. C'est une
         moitie du « truc bizarre » vu par Julien le 2026-09-21.
         ⚠️ offsetParent ne suffit PAS ici : Dawn replie son tiroir par
         `transform` et `visibility`, jamais par `display: none`, donc
         offsetParent reste non nul tiroir ferme. C'est `details.open` qu'il
         faut lire. offsetParent reste utile pour le cas ordinateur, ou
         header-drawer est bien en `display: none`. */
      var enveloppe = f.closest ? f.closest('details') : null;
      TM.machine(texte, function () {
        return document.hidden
            || !texte.offsetParent
            || !(enveloppe && enveloppe.open)
            || document.activeElement === champ
            || !!champ.value;
      });
    }

    function poserPied(conteneur) {
      if (conteneur.querySelector('.tm-pied')) return;
      var liens = [
        { url: '/account', texte: 'Mon compte',
          d: [['path', { d: 'M11 11.4 a3.6 3.6 0 1 0 0-7.2 a3.6 3.6 0 0 0 0 7.2 z' }],
              ['path', { d: 'M3.9 19.2 c0-3.6 3.2-5.6 7.1-5.6 s7.1 2 7.1 5.6' }]] },
        { url: '/pages/contactez-nous', texte: 'Nous contacter',
          d: [['path', { d: 'M2.8 5.4 h16.4 v11.2 h-16.4 z' }],
              ['path', { d: 'M2.8 5.9 L11 12 L19.2 5.9' }]] }
      ];
      var bloc = document.createElement('div');
      bloc.className = 'tm-pied';
      for (var i = 0; i < liens.length; i++) {
        var a = document.createElement('a');
        a.className = 'tm-pied__lien';
        a.setAttribute('href', liens[i].url);
        var ic = svg(liens[i].d);
        ic.setAttribute('class', 'tm-pied__icone');
        var lab = document.createElement('span');
        lab.textContent = liens[i].texte;
        a.appendChild(ic); a.appendChild(lab);
        bloc.appendChild(a);
      }
      conteneur.appendChild(bloc);
    }

    function poser() {
      var nav = document.querySelector('.menu-drawer__navigation')
             || document.querySelector('.menu-drawer__inner-container')
             || document.querySelector('.menu-drawer');
      if (nav) poserRecherche(nav);

      var bas = document.querySelector('.menu-drawer__navigation-container')
             || document.querySelector('.menu-drawer__inner-container');
      if (bas) poserPied(bas);
    }

    TM.poserTiroir = poser;
    TM.pret(poser);
  })();

  /* L'accordeon du tiroir, 2026-09-21. Complement indispensable au CSS.
     Trois choses qu'aucun CSS ne peut faire, detaillees dans
     theme/tiroir-accordeon.md :
     1. Dawn ecrit `aria-expanded="true"` sur une section qui vient de se
        REPLIER, parce qu'il ne teste jamais l'etat avant de basculer.
     2. Pour un visiteur en « animations reduites », Dawn pose son piege a
        focus immediatement puis echoue a focaliser le bouton Retour, que nous
        masquons : la tabulation s'echappe du tiroir, invisible a l'ecran.
     3. Cinq familles depliees font plus de trois ecrans de haut.
     On coupe le clic EN CAPTURE, sans preventDefault : la bascule native du
     <details> a bien lieu. Le hamburger est hors de #menu-drawer, il n'est
     jamais vu par cet ecouteur.
     Mettre OUVRIR_NOS_PRODUITS a false pour un tiroir entierement replie. */
  (function () {
    var SOUS_990 = '(max-width: 989px)';
    var OUVRIR_NOS_PRODUITS = true;
    function poserAccordeon() {
      var tiroir = document.getElementById('menu-drawer');
      if (!tiroir) return;
      /* ⚠️ Garde-fou indispensable depuis que ce bloc est rejoue dans
         l'editeur : sans lui, deux ecouteurs de clic sur le meme tiroir
         replieraient et deplieraient la famille du meme geste. */
      if (tiroir.getAttribute('data-tm-accordeon') === '1') return;
      tiroir.setAttribute('data-tm-accordeon', '1');
      var conteneur = tiroir.querySelector('.menu-drawer__navigation-container');
      var principal = document.getElementById('Details-menu-drawer-container');
      function sommaire(d) { return d.querySelector(':scope > summary'); }
      function marquer(d) {
        var s = sommaire(d);
        if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      }
      function replier(d) {
        var sous = d.querySelectorAll('details[open]');
        for (var i = 0; i < sous.length; i++) {
          sous[i].removeAttribute('open');
          sous[i].classList.remove('menu-opening');
          marquer(sous[i]);
        }
        d.removeAttribute('open');
        d.classList.remove('menu-opening');
        marquer(d);
      }
      var toutes = tiroir.querySelectorAll('details');
      for (var i = 0; i < toutes.length; i++) marquer(toutes[i]);
      tiroir.addEventListener('click', function (e) {
        if (!window.matchMedia(SOUS_990).matches) return;
        var s = e.target && e.target.closest ? e.target.closest('summary.menu-drawer__menu-item') : null;
        if (!s || !tiroir.contains(s)) return;
        e.stopPropagation();
      }, true);
      tiroir.addEventListener('toggle', function (e) {
        var d = e.target;
        if (!d || d.tagName !== 'DETAILS' || !tiroir.contains(d)) return;
        marquer(d);
        if (!d.open) { d.classList.remove('menu-opening'); return; }
        d.classList.add('menu-opening');
        var s = sommaire(d);
        var liste = d.closest('ul');
        if (!s || !liste) return;
        var avant = s.getBoundingClientRect().top;
        var freres = liste.querySelectorAll(':scope > li > details[open]');
        for (var j = 0; j < freres.length; j++) if (freres[j] !== d) replier(freres[j]);
        var apres = s.getBoundingClientRect().top;
        if (conteneur && apres !== avant) conteneur.scrollTop += (apres - avant);
      }, true);
      if (principal && OUVRIR_NOS_PRODUITS) {
        principal.addEventListener('toggle', function (e) {
          if (e.target !== principal || !principal.open) return;
          var premier = tiroir.querySelector('.menu-drawer__navigation > ul > li > details');
          if (premier && !premier.open) premier.setAttribute('open', '');
          if (conteneur) conteneur.scrollTop = 0;
        });
      }
      tiroir.addEventListener('keyup', function (e) {
        if ((e.code || '').toUpperCase() !== 'ESCAPE') return;
        var cible = e.target && e.target.closest ? e.target.closest('details[open]') : null;
        if (!cible || !tiroir.contains(cible)) return;
        e.stopPropagation();
        var s = sommaire(cible);
        replier(cible);
        if (s) s.focus();
      }, true);
    }
    TM.poserAccordeon = poserAccordeon;
    TM.pret(poserAccordeon);
  })();

  /* LA BOITE DE RECHERCHE DE L'EN-TETE. 2026-09-21.
     Dawn rend une loupe qui ouvre sa modale de recherche suggeree. On ne
     remplace pas ce mecanisme : le CSS habille le <summary> en champ, et ce
     bloc y pose seulement la phrase qui s'ecrit. La recherche suggeree de
     Dawn, ses vignettes et ses prix, continuent donc de fonctionner. Un
     formulaire a nous les aurait perdues.
     Si ce bloc ne tourne pas, la boite reste un champ avec sa loupe : rien
     n'est casse, et c'est pour ca qu'il n'y a pas de texte dans le CSS. */
  (function () {
    function poserEntete() {
      var sommaire = document.querySelector('.header > .header__search summary.header__icon--search');
      if (!sommaire || sommaire.querySelector('.tm-appel')) return;
      var hote = sommaire.querySelector(':scope > span') || sommaire;
      var boite = sommaire.closest('details');

      var bloc = document.createElement('span');
      bloc.className = 'tm-appel';
      bloc.setAttribute('aria-hidden', 'true');
      var texte = document.createElement('span');
      var curseur = document.createElement('span');
      curseur.className = 'tm-rech__curseur';
      bloc.appendChild(texte);
      bloc.appendChild(curseur);
      hote.appendChild(bloc);

      /* ⚠️ ON TESTE LE SPAN INJECTE, PAS LE SOMMAIRE. Je croyais que Dawn
         masquait cette loupe sur telephone : c'est FAUX sur cette boutique.
         En dessous de 990 px, base.css v16 passe la grille de l'en-tete a
         'left-icons search heading icons' et AFFICHE cette loupe-ci dans sa
         propre colonne, parce que les comptes clients sont actifs. Le
         sommaire est donc toujours visible, la garde ne se declenchait
         jamais, et la phrase debordait par-dessus le nom de la marque.
         Le span, lui, est mis en `display: none` sous 990 px par
         tm-entete.liquid : son offsetParent est nul, la machine se met en
         pause toute seule, et repart seule a la rotation de l'ecran. Aucun
         ecouteur de redimensionnement n'est necessaire. */
      TM.machine(texte, function () {
        return document.hidden || !bloc.offsetParent || !!(boite && boite.open);
      });
    }
    TM.poserEntete = poserEntete;
    TM.pret(poserEntete);
  })();

/* ==================================================================
   LE REJEU DANS L'EDITEUR DE THEME. 2026-09-21
   ==================================================================
   ⚠️ L'EDITEUR RE-REND UNE SECTION ENTIERE A CHAQUE REGLAGE MODIFIE.
   Le tiroir `#menu-drawer`, la loupe et le menu vivent tous dans
   `sections/header.liquid`. Donc des que Julien touche un reglage de
   l'en-tete dans l'editeur, le balisage est remplace : le champ de
   recherche, les liens de compte, la phrase qui s'ecrit et TOUS les
   ecouteurs de l'accordeon disparaissent, sans le moindre message. Il
   retrouve le tiroir brut de Dawn et croit que le travail est perdu.
   Ces trois installeurs sont idempotents, chacun par sa propre garde,
   donc les rejouer ne coute rien et ne double rien. */
document.addEventListener('shopify:section:load', function (e) {
  var cible = e && e.target;
  if (!cible || !cible.querySelector) return;
  if (!cible.querySelector('#menu-drawer, .header')) return;
  if (TM.poserTiroir) TM.poserTiroir();
  if (TM.poserAccordeon) TM.poserAccordeon();
  if (TM.poserEntete) TM.poserEntete();
});
